import { permissionsSelector } from '@air/redux-permissions';

import { useAirSelector } from '~/utils/ReduxUtils';

export type UseWorkspacePermissionsParams = {
  workspaceId: string | undefined;
};

export const useWorkspacePermissions = ({ workspaceId }: UseWorkspacePermissionsParams) => {
  const workspacePermissions = useAirSelector((st) => permissionsSelector(st, 'workspaceId', workspaceId));

  return {
    workspacePermissions,
  };
};
